/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangeProgramDepartment
 */
export interface ExchangeProgramDepartment {
    /**
     * 
     * @type {number}
     * @memberof ExchangeProgramDepartment
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ExchangeProgramDepartment
     */
    exchangeProgramMajorId: number;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramDepartment
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramDepartment
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramDepartment
     */
    departmentCode: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramDepartment
     */
    syllabusUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeProgramDepartment
     */
    syllabusUrlJp?: string;
}

export function ExchangeProgramDepartmentFromJSON(json: any): ExchangeProgramDepartment {
    return ExchangeProgramDepartmentFromJSONTyped(json, false);
}

export function ExchangeProgramDepartmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeProgramDepartment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'exchangeProgramMajorId': json['exchangeProgramMajorId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nameJa': json['nameJa'],
        'departmentCode': json['departmentCode'],
        'syllabusUrl': !exists(json, 'syllabusUrl') ? undefined : json['syllabusUrl'],
        'syllabusUrlJp': !exists(json, 'syllabusUrlJp') ? undefined : json['syllabusUrlJp'],
    };
}

export function ExchangeProgramDepartmentToJSON(value?: ExchangeProgramDepartment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'exchangeProgramMajorId': value.exchangeProgramMajorId,
        'name': value.name,
        'nameJa': value.nameJa,
        'departmentCode': value.departmentCode,
        'syllabusUrl': value.syllabusUrl,
        'syllabusUrlJp': value.syllabusUrlJp,
    };
}


